import { jsx } from 'react/jsx-runtime';
import { FormFieldWrap } from '@zooplus/ui-components';
import FormControl from '../FormControl/FormControl.js';
import styles from './EncryptedFormField.module.scss.js';

/**
 * The encrypted form field is for rendering hosted/secure field
 */
const EncryptedFormField = ({ id, errorMessage, icon, labelText, ...props }) => {
    return (jsx(FormFieldWrap, { className: styles.formFieldWrap, errorMessage: errorMessage, labelText: labelText, ...props, children: jsx(FormControl, { id: id, "data-cse": id, innerClassname: styles.noPadding, hasError: errorMessage !== null, "data-zta": "encryptedFormField", icon: icon, ...props }) }));
};

export { EncryptedFormField as default };
//# sourceMappingURL=EncyrptedFormField.js.map
